    import { TimestampFormatPipe } from '../commons/timestampFormatPipe';
    import { MatSnackBar } from '@angular/material/snack-bar';
    import { Router } from '@angular/router';
    import { DateAdapter } from '@angular/material/core';
    import { NavigatorService } from '../services/navigator.service';
    import { Component, OnInit, OnDestroy } from '@angular/core';
    import { ComponentCacheService } from '../services/component-cache.service';
    import { ResponseQueryByCriteria } from '../shared/dto/responseQueryByCriteria';
    import { GenericListComponent } from '../shared/GenericListCoumponent';
import { SoftwareService } from '../services/device-aziendali/software.service';
import { SoftwareDTO } from '../shared/dto/device-aziendali/software';
    
    @Component({
      selector: 'app-location',
      templateUrl: './software.component.html',
      styleUrls: ['./software.component.scss']
    })

    export class SoftwareComponent extends GenericListComponent implements OnInit, OnDestroy {
    
      constructor(
        private softwareService: SoftwareService,
        componentCacheService: ComponentCacheService,
        navigatorService: NavigatorService,
        dateAdapter: DateAdapter<Date>,
        router: Router,
        snackBar: MatSnackBar,
        timestampFormatPipe: TimestampFormatPipe
      ) {
        super(
          navigatorService,
          componentCacheService,
          dateAdapter,
          router,
          snackBar,
          timestampFormatPipe);
        this.displayedColumns = ['id', 'nome', 'tipologia', 'descrizione', 'signInOutDescription', 'modalitaAccesso', 'utilizzatori', 'trasferimentoDati', 'detail'];
        this.parameters = {
          dataSource: [],
          showList: false,
          filter: null,
          sortField: null,
          sortDirection: null,
          pageNumber: 0,
          pageSize: 50,
          length: 0
        } 
      }
    
      list() {
        this.softwareService.softwareList(
          this.parameters.pageNumber,
          this.parameters.pageSize,
          this.parameters.sortDirection,
          this.parameters.sortField,
          this.parameters.filter).subscribe(
            (res: ResponseQueryByCriteria<SoftwareDTO>) => {
              console.log("response : " + res);
              this.parameters.dataSource = res.content;
              this.parameters.pageNumber = res.pageNumber;
              this.parameters.length = res.totalElements;
              this.parameters.showList = true;
            }
          )
      }
    
      ngOnInit() {
        super.ngOnInit();
      }
    
      ngOnDestroy(): void {
        super.ngOnDestroy();
      }
    }
    